import React from 'react';
export function Footer() {
  return <footer className="w-full bg-forest-900 px-5 py-12 text-center text-cream/70" data-id="element-87" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-2xl" data-id="element-88" data-mp="3ggaovpzpm32t">
        <p className="font-display text-lg font-extrabold text-cream" data-id="element-89" data-mp="3gh3qydnq44em">Recursos Pro Digital™</p>
        <p className="mx-auto mt-3 max-w-xl text-[13px] leading-relaxed" data-id="element-90" data-mp="32lrn9grlb3lk">
          Recursos digitales para docentes, seños y maestras jardineras que quieren ahorrar tiempo,
          organizarse mejor y tener herramientas prácticas para el día a día de la sala.
        </p>
        <p className="mt-6 text-[11px]" data-id="element-91" data-mp="387ejk1577e7">
          © 2026 Recursos Pro Digital — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}